/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoicePerMonthResponse
 */
export interface InvoicePerMonthResponse {
    /**
     * 
     * @type {string}
     * @memberof InvoicePerMonthResponse
     */
    monthAndYear: string;
    /**
     * 
     * @type {number}
     * @memberof InvoicePerMonthResponse
     */
    paidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePerMonthResponse
     */
    pendingAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePerMonthResponse
     */
    overdueAmount: number;
}

/**
 * Check if a given object implements the InvoicePerMonthResponse interface.
 */
export function instanceOfInvoicePerMonthResponse(value: object): value is InvoicePerMonthResponse {
    if (!('monthAndYear' in value) || value['monthAndYear'] === undefined) return false;
    if (!('paidAmount' in value) || value['paidAmount'] === undefined) return false;
    if (!('pendingAmount' in value) || value['pendingAmount'] === undefined) return false;
    if (!('overdueAmount' in value) || value['overdueAmount'] === undefined) return false;
    return true;
}

export function InvoicePerMonthResponseFromJSON(json: any): InvoicePerMonthResponse {
    return InvoicePerMonthResponseFromJSONTyped(json, false);
}

export function InvoicePerMonthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicePerMonthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'monthAndYear': json['monthAndYear'],
        'paidAmount': json['paidAmount'],
        'pendingAmount': json['pendingAmount'],
        'overdueAmount': json['overdueAmount'],
    };
}

export function InvoicePerMonthResponseToJSON(value?: InvoicePerMonthResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'monthAndYear': value['monthAndYear'],
        'paidAmount': value['paidAmount'],
        'pendingAmount': value['pendingAmount'],
        'overdueAmount': value['overdueAmount'],
    };
}

